<template>
  <van-popup v-model="isPopShow" position="bottom" round>
    <van-datetime-picker
      v-model="time"
      type="date"
      :max-date="currentTime"
      :formatter="formatter"
      :visible-item-count="5"
      :title='title'
      @cancel="cancelPicker"
      @confirm="confirmPicker"
      show-toolbar
    />
  </van-popup>
</template>

<script>
export default {
  name: "DatePicker",
  data(){
    return{
      time: new Date(), // 开始时间不能超过当前时间
      currentTime: new Date(), // 开始时间不能超过当前时间
      isPopShow: false, // 弹出层隐藏与显示
    }
  },
  props: {
    title: {
      type: String,
      default: '请选择日期'
    }
  },
  methods: {
    init(){
      this.isPopShow = true;
    },
    formatter(type, value) {// 格式化选择器日期
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    cancelPicker() { // 选择器取消按钮点击事件
      this.isPopShow = false;
    },
    confirmPicker(value) {// 确定按钮，时间格式化并显示在页面上
      var date = value;
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = date.getFullYear() + "-" + m + "-" + d
      this.isPopShow = false;
      this.$emit('selectedDate',timer)
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/h5/DatePicker.vue